import {HttpClient} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SecurityLevel } from "../interfaces/security-level";
import { environment } from "src/environments/environment";
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityLevelsApiService {
  constructor(private httpClient: HttpClient, private authService: AuthenticationService) { }


  getSecurityLevels(): Observable<SecurityLevel[]>{
    console.log('Отправили запрос на получение секретностей');
    return this.httpClient.post<SecurityLevel[]>( environment.servers[environment.srv_mode].host + "/security_levels",{user:this.authService.getUser()});
    
  }
}
